import portfolio1 from "../assets/portfolio/portfolio1.png";
import portfolio2 from "../assets/portfolio/portfolio2.png";
import portfolio3 from "../assets/portfolio/portfolio3.png";
import portfolio4 from "../assets/portfolio/portfolio4.png";
import portfolio5 from "../assets/portfolio/portfolio5.png";
import portfolio6 from "../assets/portfolio/portfolio6.png";
import portfolio7 from "../assets/portfolio/portfolio7.png";
import portfolio8 from "../assets/portfolio/portfolio8.png";
import portfolio9 from "../assets/portfolio/portfolio9.png";
import portfolio10 from "../assets/portfolio/portfolio10.jpg";
import portfolio11 from "../assets/portfolio/portfolio11.jpg";
import portfolio12 from "../assets/portfolio/portfolio12.jpg";
import portfolio13 from "../assets/portfolio/portfolio13.png";
import portfolio14 from "../assets/portfolio/portfolio14.png";
import portfolio15 from "../assets/portfolio/portfolio15.png";
import portfolio16 from "../assets/portfolio/portfolio16.png";
import portfolio17 from "../assets/portfolio/portfolio17.png";
import portfolio18 from "../assets/portfolio/portfolio18.png";
import portfolio19 from "../assets/portfolio/portfolio19.png";
import portfolio20 from "../assets/portfolio/portfolio20.png";

let portfolios = [
  {
    id: "01",
    title: "Portfolio",
    alt: "CariKost - UI/UX Design Web",
    imgUrl: portfolio1,
    category: ["all", "design"],
    desc: "This is my portfolio design",
  },
  {
    id: "02",
    title: "Portfolio",
    alt: "SayDrones - UI/UX Design Mobile",
    imgUrl: portfolio2,
    category: ["all", "design"],
    desc: "This is my portfolio design.",
  },
  {
    id: "03",
    title: "Portfolio",
    alt: "WarunkOnline - UI/UX Design Web",
    imgUrl: portfolio3,
    category: ["all", "design"],
    desc: "This is my portfolio design.",
  },
  {
    id: "04",
    title: "Portfolio",
    alt: "WarunkOnline - UI/UX Design Mobile",
    imgUrl: portfolio4,
    category: ["all", "design"],
    desc: "This is my portfolio design.",
  },
  {
    id: "05",
    title: "Portfolio",
    alt: "Face Recognition",
    imgUrl: portfolio5,
    category: ["all", "other"],
    desc: "Build Face Recognition with Python.",
  },
  {
    id: "06",
    title: "Portfolio",
    alt: "Build Simple Authentication App using PHP Native",
    imgUrl: portfolio6,
    category: ["all", "web"],
    desc: "This is my portfolio design.",
  },
  {
    id: "07",
    title: "Portfolio",
    alt: "Build ECommerce Website using PHP CodeIgniter",
    imgUrl: portfolio7,
    category: ["all", "web"],
    desc: "Build ECommerce Website using PHP CodeIgniter.",
  },
  {
    id: "08",
    title: "Portfolio",
    alt: "Build Simple Order App using Java Spring",
    imgUrl: portfolio8,
    category: ["all", "web"],
    desc: "This is my portfolio design.",
  },
  {
    id: "09",
    title: "Portfolio",
    alt: "Build Todo List App using PHP CodeIgniter",
    imgUrl: portfolio9,
    category: ["all", "web"],
    desc: "This is my portfolio design.",
  },
  {
    id: "10",
    title: "Portfolio",
    alt: "SiJantung - Aplikasi diagnosa penyakit jantung",
    imgUrl: portfolio10,
    category: ["all", "web", "design"],
    desc: "This is my portfolio design.",
  },
  {
    id: "11",
    title: "Portfolio",
    alt: "Waras - COVID-19 Diagnosis App",
    imgUrl: portfolio11,
    category: ["all", "design", "mobile"],
    desc: "This is my portfolio design.",
  },
  {
    id: "12",
    title: "Portfolio",
    alt: "ECanteen - Canteen Ordering App",
    imgUrl: portfolio12,
    category: ["all", "design", "web"],
    desc: "This is my portfolio design.",
  },
  {
    id: "13",
    title: "Portfolio",
    alt: "Dokterku - Doctor Appointment App",
    imgUrl: portfolio13,
    category: ["all", "web"],
    desc: "This is my portfolio design.",
  },
  {
    id: "14",
    title: "Portfolio",
    alt: "SIAMA - Academic Information System",
    imgUrl: portfolio14,
    category: ["all", "web", "design"],
    desc: "This is my portfolio design.",
  },
  {
    id: "15",
    title: "Portfolio",
    alt: "ENFT - Trade your NFT",
    imgUrl: portfolio15,
    category: ["all", "mobile"],
    desc: "Trade your NFT.",
  },
  {
    id: "16",
    title: "Portfolio",
    alt: "Zillenials Class Web Design",
    imgUrl: portfolio16,
    category: ["all", "web", "design"],
    desc: "This is my portfolio design.",
  },
  {
    id: "17",
    title: "Portfolio",
    alt: "HultPrize Web Design",
    imgUrl: portfolio17,
    category: ["all", "web", "design"],
    desc: "This is my portfolio design.",
  },
  {
    id: "18",
    title: "Portfolio",
    alt: "ECanteen Mobile Design",
    imgUrl: portfolio18,
    category: ["all", "mobile", "design"],
    desc: "This is my portfolio design.",
  },
  {
    id: "19",
    title: "Portfolio",
    alt: "Zillenials Mobile Design",
    imgUrl: portfolio19,
    category: ["all", "Mobile", "design"],
    desc: "This is my portfolio design.",
  },
  {
    id: "20",
    title: "Portfolio",
    alt: "SiDang - Sistem Informasi Gudang",
    imgUrl: portfolio20,
    category: ["all", "web"],
    desc: "This is my portfolio design.",
  },
];

export default portfolios;
